import React from 'react';
import { SVGProps } from '@/components/icon/Icon.types';

export const Edit = ({
  className,
  color = '#00304D',
  width = 24,
  height = 24,
}: SVGProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      focusable="false"
      aria-hidden="true"
    >
      <path
        d="M4 16.6671V20h3.33287l9.82973-9.8297-3.3329-3.33292L4 16.6671Zm15.74-9.07427c.3467-.34661.3467-.90654 0-1.25316l-2.0797-2.07971c-.3466-.34661-.9065-.34661-1.2531 0L14.7807 5.8864l3.3329 3.33287L19.74 7.59283Z"
        fill={color}
      />
    </svg>
  );
};
